import { render } from "./SegmentationRow.vue?vue&type=template&id=5609abd4&scoped=true"
import script from "./SegmentationRow.vue?vue&type=script&lang=js"
export * from "./SegmentationRow.vue?vue&type=script&lang=js"

import "./SegmentationRow.vue?vue&type=style&index=0&id=5609abd4&lang=scss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5609abd4"]])

export default __exports__